import { Banner } from "../../molecules/common";
import newsList from "../../../constant/newsLetters.json";
import moment from "moment";
import { Button } from "../../atoms/common";

const ConnectWithUsPage = () => {
  return (
    <div className="container">
      <section>
        <Banner imgUrl="https://www.softechlogix.com/wp-content/uploads/2017/02/fowler-background.jpg">
          <div className="h-full text-white flex items-center px-28 tablet:px-10">
            <div className="flex flex-col items-start">
              <div className="bg-slate-700/[0.5] p-4 mt-4 border-l-4">
                <h1 className="font-bold text-4xl whitespace-pre">
                  Connect With Us
                </h1>
              </div>
            </div>
          </div>
        </Banner>
      </section>
      <section className="w-full h-full p-5 flex tablet:block font-inter">
        <div className="w-[70%] tablet:w-full p-2">
          <div className="h-full w-full bg-gray-200 px-2 py-3 flex flex-col">
            <div>
              <h1 className="font-bold text-xl text-blueWebsite">Contact Us</h1>
            </div>
          </div>
        </div>
        <aside className="w-[30%] tablet:w-full p-2">
          <div className="h-full w-full bg-gray-200 px-2 py-3">
            <div>
              <h1 className="font-bold text-xl text-blueWebsite">News Letter</h1>
            </div>
            {newsList.map((item) => (
              <div className="py-3 text-sm text-blueWebsite font-normal border-b border-blueWebsite">
                <span>
                  {moment(item.startDate, 'YYYY-MM-DD').format('MMMM')}
                  {item.endDate && ` & ${moment(item.endDate, 'YYYY-MM-DD').format('MMMM')}`}
                </span>
              </div>
            ))}
          </div>
        </aside>
      </section>
      <section className="font-inter w-full h-full flex flex-col p-5">
          <div className="flex justify-between p-2">
              <h1 className="text-xl text-blueWebsite font-bold">News</h1>
              <Button
                classes="bg-transparent p-2 text-sm text-blueWebsite"
                text="See all"
                handler={()=>{}}
              />
          </div>
          <div className="flex flex-nowrap">
          </div>
      </section>
    </div>
  );
};

export default ConnectWithUsPage;
